/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { action, observable, computed } from 'mobx';
import { Auth } from '@stores/auth/auth';
import { auth } from '@stores/auth/decorators';
import { loader } from '@stores/loading/decorators';
import { Loading } from '@stores/loading/loading';
import { notify } from '@stores/notifications/decorators';
import { Notifications } from '@stores/notifications/notifications';
import { Request } from './requests';
import { ExtendedLinkedAccount } from './types';
import { extendLinkedAccounts } from './utils';

export class LinkedAccounts {
  @observable items: ExtendedLinkedAccount[] = [];

  constructor(private auth: Auth, private loading: Loading, private notifications: Notifications) {
    this.loading.registerLoader('linked-accounts-list', true);
  }

  @action.bound
  setItems(items: ExtendedLinkedAccount[]): void {
    this.items = items;
  }

  @loader('linked-accounts-list')
  @notify()
  @auth
  async loadLinkedAccounts(): Promise<void> {
    await Request.list()
      .then(extendLinkedAccounts)
      .then(this.setItems);
  }

  @computed get loginLinkedAccounts(): ExtendedLinkedAccount[] {
    return this.items.filter(item => item.type === 'LOG_IN');
  }

  @computed get extraLinkedAccounts(): ExtendedLinkedAccount[] {
    return this.items.filter(item => item.type === 'EXTRA');
  }
}
